import { REACT_APP_KEY_RE_CAPTCHA } from 'config';

export const GRECAPTCHA_SCRIPT_URL = `https://www.google.com/recaptcha/enterprise.js?render=${REACT_APP_KEY_RE_CAPTCHA}`;

/* eslint-disable @typescript-eslint/no-explicit-any */
export async function getGrecaptchaToken(action: string) {
  if ((window as any).grecaptcha?.enterprise?.execute) {
    const token = await (window as any).grecaptcha?.enterprise?.execute(
      REACT_APP_KEY_RE_CAPTCHA,
      {
        action,
      },
    );
    // .then(function (token: string) {
    //   console.log(token);
    //   return token;
    // });
    return token;
  }
}
